module.exports = __webpack_public_path__ + "img/ic_setting_ok.51f413de.png";